// ─────────────────────────────────────────────
//  Sidebar — main dashboard navigation
// ─────────────────────────────────────────────
import { NAV_ITEMS } from "../lib/data";

export default function Sidebar({ nav, setNav, business }) {
  return (
    <div
      style={{
        background: "rgba(255,255,255,0.025)",
        borderRight: "1px solid rgba(255,255,255,0.07)",
        display: "flex",
        flexDirection: "column",
        padding: "0 0 24px",
        minHeight: "100vh",
      }}
    >
      {/* Logo */}
      <div
        style={{
          padding: "22px 20px 18px",
          borderBottom: "1px solid rgba(255,255,255,0.07)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 34, height: 34, borderRadius: 10,
              background: "linear-gradient(135deg,#FF6B35,#FFBE0B)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 18,
            }}
          >
            ⚡
          </div>
          <div>
            <div style={{ fontWeight: 900, fontSize: 16, letterSpacing: "-0.04em", lineHeight: 1 }}>
              JiffyReview
            </div>
            <div style={{ fontSize: 9, color: "rgba(255,255,255,0.3)", letterSpacing: "0.05em" }}>
              jiffyreview.com
            </div>
          </div>
        </div>
      </div>

      {/* Business pill */}
      <div
        style={{
          margin: "14px 12px",
          background: "rgba(255,107,53,0.12)",
          border: "1px solid rgba(255,107,53,0.2)",
          borderRadius: 10,
          padding: "10px 12px",
          display: "flex", gap: 10, alignItems: "center",
        }}
      >
        <div style={{ fontSize: 22 }}>{business.emoji}</div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 700 }}>{business.name}</div>
          <div style={{ fontSize: 10, color: "rgba(255,255,255,0.35)" }}>{business.location}</div>
        </div>
      </div>

      {/* Nav items */}
      <div style={{ padding: "6px 10px", flex: 1 }}>
        {NAV_ITEMS.map((item) => (
          <button
            key={item.id}
            onClick={() => setNav(item.id)}
            style={{
              width: "100%",
              textAlign: "left",
              background: nav === item.id ? "rgba(255,255,255,0.07)" : "transparent",
              border: "none",
              borderRadius: 9,
              padding: "10px 12px",
              cursor: "pointer",
              color: nav === item.id ? "#fff" : "rgba(255,255,255,0.35)",
              fontWeight: nav === item.id ? 700 : 400,
              fontSize: 13,
              fontFamily: "inherit",
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 2,
              transition: "all 0.15s",
            }}
          >
            <span style={{ fontSize: 16, opacity: 0.8 }}>{item.icon}</span>
            {item.label}
            {/* Red badge on Reviews when there's a flagged review */}
            {item.id === "reviews" && (
              <span
                style={{
                  marginLeft: "auto", fontSize: 10,
                  background: "rgba(211,35,35,0.25)", color: "#ff8080",
                  borderRadius: 8, padding: "2px 7px", fontWeight: 700,
                }}
              >
                1
              </span>
            )}
          </button>
        ))}
      </div>

      <div style={{ padding: "12px 20px", borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        <div style={{ fontSize: 10, color: "rgba(255,255,255,0.2)", textAlign: "center" }}>
          ⚡ JiffyReview · Pro Plan
        </div>
      </div>
    </div>
  );
}
